var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsNl = function SvgNnIconFlagsNl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.25 32.25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005fd9",
    d: "M16.12 32.12a16 16 0 0 0 15-10.45h-30a16 16 0 0 0 15 10.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.12 10.57h-30a15.75 15.75 0 0 0 0 11.1h30a15.75 15.75 0 0 0 0-11.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f20000",
    d: "M16.12.12a16 16 0 0 0-15 10.45h30a16 16 0 0 0-15-10.45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.13,
    cy: 16.13,
    r: 16,
    fill: "none",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
};
export default SvgNnIconFlagsNl;